import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
// Area Navigation component
// This file was once generated when you created this area
// but you can edit it freely
import { ClipboardCheckIcon } from '@moia-dev/pace-icons'
import { ServiceSettingsAreaRoutes } from './ServiceSettingsAreaRoutes'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const ServiceSettingsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ServiceSettingsAreaRoutes.route}
      Icon={ClipboardCheckIcon}
    />
  )
}
